import { render, staticRenderFns } from "./SourcesTab.vue?vue&type=template&id=63061b6a&scoped=true"
import script from "./SourcesTab.vue?vue&type=script&lang=js"
export * from "./SourcesTab.vue?vue&type=script&lang=js"
import style0 from "./SourcesTab.vue?vue&type=style&index=0&id=63061b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63061b6a",
  null
  
)

export default component.exports